/* unplugin-vue-components disabled */import script from "./topTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./topTitle.vue?vue&type=script&setup=true&lang=js"

import "./topTitle.vue?vue&type=style&index=0&id=cfc3642e&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfc3642e"]])

export default __exports__